<template>
  <div
    class="d-flex flex-column align-center justify-end"
    style="min-height:100vh; min-width:100vw"
  >
    <div class="clock">
      <p class="white--text mb-0 font-weight-bold">{{timer | minuteSeconds}}</p>
    </div>

    <div id="remote">
      <div
        v-if="!acceptedCall"
        class="justify-self-center align-self-center d-flex flex-column align-center justify-center"
      >
        <img style="height:200px; width:200px" src="@/assets/pat.png" alt />
        <p class="mb-0 text-center mt-2 white--text" v-if="loading">Η βιντεοκλήση είναι σε εξέλιξη.</p>
        <p class="text-center white--text" v-if="loading">Παρακαλώ περιμένετε...</p>
      </div>
    </div>

    <div v-show="!disabled" id="local"></div>

    <div class="buttons d-flex justify-center align-center mb-12 mr-12">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="50"
            width="50"
            fab
            depressed
            outlined
            color="white"
            v-on="on"
            @click="disableMic"
          >
            <v-icon v-if="!disabledMic">mdi-microphone-off</v-icon>
            <v-icon v-else>mdi-microphone</v-icon>
          </v-btn>
        </template>
        <span>{{disabledMic ? 'Άνοιγμα μικρόφωνου' : 'Κλείσιμο μικρόφωνου'}}</span>
      </v-tooltip>

      <v-btn
        height="50"
        width="50"
        fab
        depressed
        color="rgb(255,0,0)"
        class="white--text ml-2"
        @click="end"
      >
        <v-icon>mdi-phone-hangup</v-icon>
      </v-btn>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            class="ml-2"
            height="50"
            width="50"
            fab
            depressed
            outlined
            color="white"
            v-on="on"
            @click="disable"
          >
            <v-icon v-if="!disabled">mdi-video-off</v-icon>
            <v-icon v-else>mdi-video</v-icon>
          </v-btn>
        </template>
        <span>{{disabled ? 'Άνοιγμα κάμερας' : 'Κλείσιμο κάμερας'}}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
const { connect, createLocalVideoTrack } = require("twilio-video");
const signalR = require("@microsoft/signalr");

export default {
  data() {
    return {
      room: null,
      disabled: false,
      disabledMic: false,
      localTrack: null,
      timer: 0,
      interval: null,
      remoteDisabled: true,
      loading: true,
      acceptedCall: false
    };
  },
  destroyed() {
    // this.localTrack.stop();

    if (this.interval !== null) {
      clearInterval(this.interval);
    }
    if (this.localTrack !== null) {
      this.localTrack.stop();
    }

    if (!!this.room) {
      // if (this.room.state === "connected") {
      this.room.disconnect();

      console.log("disconnected from destroyed");
      // }
      this.localTrack.stop();
    }

    this.$store.dispatch('setRatingDialog',true)

    //this.room.disconnect();
  },
  methods: {
    disable() {
      this.disabled = !this.disabled;
      if (this.disabled === true) {
        this.room.localParticipant.videoTracks.forEach(track => {
          track.track.disable();
        });
      } else {
        this.room.localParticipant.videoTracks.forEach(track => {
          track.track.enable();
        });
      }
    },

    disableMic() {
      this.disabledMic = !this.disabledMic;
      if (this.disabledMic === true) {
        this.room.localParticipant.audioTracks.forEach(track => {
          track.track.disable();
        });
      } else {
        this.room.localParticipant.audioTracks.forEach(track => {
          track.track.enable();
        });
      }
    },
    end() {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
      //this.$store.state.connection.invoke('endCall', this.$store.state.object)
      if (this.room !== null) {
        this.room.disconnect();
      }

      if (this.localTrack !== null) {
        this.localTrack.stop();
      }

      this.$store
        .dispatch("setTempObject", this.$store.state.object)
        .then(() => {
          Axios.post(`${process.env.VUE_APP_BASE_URL}/system/endVideoCall`, {
            ...this.$store.state.object,
            endReason: "doctor"
          }).then(() => {
            //  this.$router.go(-1);
            //  this.localTrack.stop();
            this.$router
              .replace("/home")
              .then()
              .catch(err => {});
            // this.$store.dispatch("setObject", null);
            //this.localTrack.stop();
          });
        });

      // this.$router.go(-1);

      // Axios.post(`${process.env.VUE_APP_BASE_URL}/system/endVideoCall`, {
      //   ...this.$store.state.object,
      //   endReason: "doctor"
      // }).then(() => {
      //   // this.$router.go(-1);
      //   this.$router.replace("/home");
      //this.$store.dispatch("setObject", null);
      //   this.localTrack.stop();
      // });
    }
  },
  created() {
    if (this.$store.state.object === null) {
      //this.localTrack.stop();
      // this.$store.dispatch("setObject", null);
      //  this.$router.go(-1);
      this.$router
        .replace("/home")
        .then()
        .catch(err => {});
      //this.$router.go()
    } else {
      this.interval = setInterval(() => {
        this.timer++;
      }, 1000);

      connect(this.$route.params.doctorTwilioToken, {
        name: this.$route.params.videoCallRoom
      })
        .then(room => {
          const localParticipant = room.localParticipant;
          console.log(
            `Connected to the Room as LocalParticipant "${localParticipant.identity}"`
          );

          this.room = room;

          room.localParticipant.videoTracks.forEach(track => {
            const localMediaContainer = document.getElementById("local");
            localMediaContainer.setAttribute("playsinline", true);
            localMediaContainer.appendChild(track.track.attach());

            this.localTrack = track.track;
          });

          console.log(room);

          // Log any Participants already connected to the Room
          room.participants.forEach(participant => {
            console.log(
              `Participant "${participant.identity}" is connected to the Room`
            );

            this.acceptedCall = true;
            this.loading = false;

            participant.tracks.forEach(publication => {
              if (publication.isSubscribed) {
                const track = publication.track;
                document.getElementById("remote").appendChild(track.attach());
              }
            });

            participant.on("trackSubscribed", track => {
              document.getElementById("remote").appendChild(track.attach());
            });

            participant.on("trackUnsubscribed", track => {
              console.log("unsub", track);
            });

            participant.on("trackDisabled", track => {
              if (track.kind === "video") {
                document
                  .getElementById("remote")
                  .removeChild(document.getElementsByTagName("video")[0]);
                //this.remoteDisabled = true;
                this.acceptedCall = false;
              }
            });

            participant.on("trackEnabled", track => {
              if (track.kind === "video") {
                //this.remoteDisabled = false;
                document
                  .getElementById("remote")
                  .appendChild(track.track.attach());
                this.acceptedCall = true;
              }
            });
          });

          // Log Participants as they disconnect from the Room
          room.once("participantDisconnected", participant => {
            console.log(
              `Participant "${participant.identity}" has disconnected from the Room`
            );
            this.$store
              .dispatch("setObject", this.$store.state.object)
              .then(() => {
                this.$store
                  .dispatch("setCurrentAvailability", {
                    isCurrentlyAvailable: true
                  })
                  .then(() => {
                    this.$router
                      .replace("/home")
                      .then()
                      .catch(err => {});
                  })
                  .catch(err => {
                    console.log(err);
                  });
                // Axios.post(
                //   `${process.env.VUE_APP_BASE_URL}/system/endVideoCall`,
                //   {
                //     ...this.$store.state.object,
                //     endReason: "doctor"
                //   }
                // ).then(() => {
                //  this.$router.go(-1);

                //});
              });
          });

          room.on("participantConnected", participant => {
            console.log(`Participant "${participant.identity}" connected`);
            this.acceptedCall = true;
            this.loading = false;
            participant.tracks.forEach(publication => {
              if (publication.isSubscribed) {
                const track = publication.track;
                document.getElementById("remote").appendChild(track.attach());
              }
            });

            participant.on("trackSubscribed", track => {
              document.getElementById("remote").appendChild(track.attach());
            });

            participant.on("trackUnsubscribed", track => {
              console.log("unsub", track);
            });

            participant.on("trackDisabled", track => {
              if (track.kind === "video") {
                document
                  .getElementById("remote")
                  .removeChild(document.getElementsByTagName("video")[0]);
                //this.remoteDisabled = true;
                this.acceptedCall = false;
              }
            });

            participant.on("trackEnabled", track => {
              if (track.kind === "video") {
                //this.remoteDisabled = false;
                document
                  .getElementById("remote")
                  .appendChild(track.track.attach());
                this.acceptedCall = true;
              }
            });
          });
        })

        // .catch(err => {
        //   this.$router.replace("/home");
        //   //  this.$store.state.connection.invoke('endCall',this.$store.state.object)
        //   console.log("hey", err);
        // });
        // })
        .catch(err => {
          console.log("give permission please", err);
          Axios.post(`${process.env.VUE_APP_BASE_URL}/system/endVideoCall`, {
            ...this.$store.state.object,
            endReason: "doctor"
          }).then(() => {
            if (err.code === 0 || err.name === "NotAllowedError") {
              console.log("what");
              this.$store.dispatch("noPermission").then(() => {
                this.$router
                  .replace("/home")
                  .then()
                  .catch(err => {});
              });
            } else {
              this.$router
                .replace("/home")
                .then()
                .catch(err => {});
            }
          });
        });

      // .catch(err=> {
      //   console.log('query err',EvalError)
      // })
    }
  },
  filters: {
    minuteSeconds: function(value) {
      const minutes = Math.floor(value / 60);
      return (
        minutes.toString().padStart(2, "0") +
        ":" +
        (value - minutes * 60).toString().padStart(2, "0")
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.clock {
  position: absolute;
  top: 50px;
  //right: 10px;
  z-index: 10;
}
</style>


